import CryptoJS from "crypto-js";

export const safeDecryptId = (encryptedId, secretKey) => {
  try {
    if (!encryptedId || !secretKey) return null;

    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedId), secretKey);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    console.error("safeDecryptId error:", error);
    return null;
  }
};
